import { Globals } from "../CoreApp/Globals";

export function prepHandleEvent(_source, mouseMoveEvent, x, y) {
  var myApp = Globals._app;
  if (myApp) myApp.PrepHandleEvent(mouseMoveEvent, x, y);
  else console.log("myApp null");

  return myApp;
}
